import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: idsTokens.iconButton.default.color.icon.enabled,
    backgroundColor: idsTokens.iconButton.default.color.background.enabled,

    '&:hover': {
      color: idsTokens.iconButton.default.color.icon.hover,
      backgroundColor: idsTokens.iconButton.default.color.background.hover,
    },

    '&.Mui-focusVisible': {
      color: idsTokens.iconButton.default.color.icon.focus,
      backgroundColor: idsTokens.iconButton.default.color.background.focus,
      outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
      outlineOffset: 1,
    },

    '&:active': {
      color: idsTokens.iconButton.default.color.icon.pressed,
      backgroundColor: idsTokens.iconButton.default.color.background.pressed,
    },

    '&:disabled': {
      color: idsTokens.iconButton.default.color.icon.disabled,
      backgroundColor: idsTokens.iconButton.default.color.background.disabled,
    },
  },
});
